import surroundGraph from './components/surroundGraph';
import treeGraph from './components/treeGraph';
export default {
  name: 'graph',
  components: {
    surroundGraph,
    treeGraph
  },
  data() {
    return {};
  }
};